import { render, staticRenderFns } from "./InvestorOnboardingAddressData.vue?vue&type=template&id=1b8a76ce&scoped=true&"
import script from "./InvestorOnboardingAddressData.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingAddressData.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingAddressData.vue?vue&type=style&index=0&id=1b8a76ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a76ce",
  null
  
)

export default component.exports